import { List } from 'immutable'
import moment from 'moment'
import { HttpResult } from 'widgets-for-react'
import { htmlDecode, mockedImageStyleMap, PaginatedItemStone } from '../../drupal/api.mod'
import { getDrupalLanguage } from '../../drupal/types_and_parser/extra_types.mod'
import { overviewpage_src, overviewpage_srcset } from '../utils/extra_images.mod'
import { defaultLanguage, getLangFromUrl } from '../utils/history.mod'
import { ParsedOverviewDetailItem, Tags } from './state'
import { tagToTaxonomy, PageKind } from './utils'

export const getOverviewItems = async (
  pageKind: PageKind,
  tags: Tags,
  searchQuery: string,
  page_index: number,
  itemsPerPage: number = 10,
  lang: string = getDrupalLanguage(getLangFromUrl())
): Promise<HttpResult<PaginatedItemStone<ParsedOverviewDetailItem>>> => {
  const res = await fetch('/api/v1/GetOverviewItems/', {
    headers: { 'Content-Type': 'application/json' },
    method: 'post',
    credentials: 'include',
    body: JSON.stringify({
      pageKind: pageKind,
      file_name: pageKind,
      lang: lang == defaultLanguage ? '' : lang,
      taxonomies_to_filter: tags
        .map((v, k) => ({
          taxonomy_title: tagToTaxonomy(k),
          taxonomy_items_to_select: v ? v.filter((t) => t != '').map((t) => htmlDecode(t)) : []
        }))
        .valueSeq()
        .toArray(),
      searchQuery: searchQuery || '',
      start_index: page_index || 0,
      page_size: itemsPerPage
    })
  })

  if (!res.ok)
    return {
      kind: 'result',
      status: 200,
      value: { items: List(), pager: { currentPage: 0, itemsPerPage: 0, totalItems: 0, totalPages: 0 } }
    }

  try {
    const json = await res.json()

    const items = json.Items.map(
      (item: any): ParsedOverviewDetailItem => ({
        Title: htmlDecode(item.Title || ''),
        Tags: item.Tags,
        Description: item.Description ? item.Description : '',
        Link: { url: item.LinkUrl ? item.LinkUrl : '', title: item.LinkTitle ? item.LinkTitle : '' },
        Image: item.Image ? mockedImageStyleMap(item.Image) : undefined,
        ImageAltText: item.ImageAltText ? item.ImageAltText : undefined,
        get_default_data_src: overviewpage_src,
        get_default_data_srcset: overviewpage_srcset,
        Author: item.Author ? item.Author : undefined,
        ReadingTime:
          item.ReadingTime && !isNaN(parseInt(item.ReadingTime)) && parseInt(item.ReadingTime) > 0
            ? parseInt(item.ReadingTime)
            : undefined,
        CreationDate: item.CreationDate
          ? new Date(item.CreationDate).getFullYear() > 1950
            ? moment(new Date(item.CreationDate)).format('YYYY-MM-DD')
            : undefined
          : undefined
      })
    )

    return {
      kind: 'result',
      status: 200,
      value: {
        items: List(items),
        pager: {
          currentPage: json.PageIndex,
          totalItems: json.TotalCount,
          totalPages: json.NumPages,
          itemsPerPage: json.PageSize
        }
      }
    }
  } catch (e) {
    console.error(e)
    return {
      kind: 'result',
      status: 200,
      value: {
        items: List(),
        pager: { currentPage: 0, itemsPerPage: 0, totalItems: 0, totalPages: 0 }
      }
    }
  }
}
